import React from 'react';
export default function ComeOnLogoBox(props) {
    return (
        <svg x="0px" y="0px" viewBox="0 0 400 130.1" enableBackground="0 0 400 130.1" {...props}>
            <path
                fill="#282B33"
                d="M387,0H13C5.8,0,0,5.8,0,13v104.1c0,7.2,5.8,13,13,13h374c7.2,0,13-5.8,13-13V13C400,5.8,394.1,0,387,0z"
            />
            <path
                fill="#F9F9F9"
                d="M58.1,78.3c-6.8,0-12.3-5.5-12.3-12.3c0-6.8,5.5-12.3,12.3-12.3c4.4,0,8.3,2.3,10.4,5.8l6-9.4
	c-4.2-4.3-10-7-16.4-7c-12.6,0-22.9,10.3-22.9,22.9s10.3,22.9,22.9,22.9c6.3,0,12.1-2.6,16.2-6.8l-5.9-9.4
	C66.2,76.1,62.4,78.3,58.1,78.3z"
            />
            <path
                fill="#8EB50D"
                d="M318.5,43.2c-11.1,0-20.2,8.2-20.2,19.3v25.1h11.4V62.9c0-4.8,3.9-8.8,8.8-8.8c4.8,0,8.8,4,8.8,8.8v24.7h11.4
	V62.5C338.6,51.4,329.6,43.2,318.5,43.2z"
            />
            <path
                fill="#F9F9F9"
                d="M100.6,43.2c-7.3,0-13.9,3.5-18.1,8.9c-1.3,1.6-2.3,3.5-3.1,5.4c-1.1,2.6-1.7,5.5-1.7,8.6c0,3,0.6,5.9,1.7,8.6
	c0.8,1.9,1.8,3.8,3.1,5.4c4.2,5.4,10.7,8.9,18.1,8.9c12.6,0,22.9-10.3,22.9-22.9S113.2,43.2,100.6,43.2z M100.6,78.3
	c-3.3,0-6.3-1.3-8.5-3.5c-2.3-2.2-3.7-5.3-3.7-8.8c0-3.4,1.4-6.4,3.6-8.7c2.2-2.2,5.3-3.6,8.7-3.6c6.8,0,12.3,5.5,12.3,12.3
	C112.9,72.8,107.4,78.3,100.6,78.3z"
            />
            <path
                fill="#8EB50D"
                d="M268.7,43.2c-12.6,0-22.9,10.3-22.9,22.9s10.3,22.9,22.9,22.9s22.9-10.3,22.9-22.9S281.3,43.2,268.7,43.2z
	 M268.7,78.3c-6.8,0-12.3-5.5-12.3-12.3c0-6.8,5.5-12.3,12.3-12.3S281,59.3,281,66C281,72.8,275.5,78.3,268.7,78.3z"
            />
            <path
                fill="#F9F9F9"
                d="M239.6,63c-0.5-5.8-2.9-10.8-7-14.4c-3.9-3.5-9.2-5.4-14.7-5.4c-5.9,0-11.5,2.3-15.6,6.6
	c-4.2,4.3-6.5,10.2-6.5,16.6c0,6.7,2.4,12.4,6.9,16.6c4.2,3.9,9.9,6,16.1,6c7.7,0,13.9-2.6,18.6-7.8l-7.4-6.6c-2.7,3-6.4,4.5-11,4.5
	c-2.9,0-5.7-0.8-8-2.3c-2.4-1.6-4.1-3.7-4.8-6.3l-0.1-0.3l33.3,0C239.5,70.1,239.9,67,239.6,63z M206.1,62c1-4.6,5.3-9.3,11.8-9.3
	c3.2,0,6,1.1,8.1,3.1c1.7,1.6,3,3.8,3.6,6.2H206.1z"
            />
            <path
                fill="#F9F9F9"
                d="M171.6,43.5c-4.6,0-8.8,1.8-11.9,4.8c-3.1-2.9-7.3-4.8-11.9-4.8c-9.6,0-17.4,7.8-17.4,17.4v26.8h10.8v-9.8v-17
	v0h0c0-3.6,2.9-6.5,6.5-6.5c3.6,0,6.5,2.9,6.5,6.5h0v0v17v9.8h10.8v-9.8v-17v0h0c0-3.6,2.9-6.5,6.5-6.5s6.5,2.9,6.5,6.5h0v0v17v9.8
	H189V60.8C189,51.3,181.2,43.5,171.6,43.5z"
            />
            <g>
                <rect x="346.9" y="77.7" fill="#8EB50D" width="10.6" height="9.9" />
                <polygon fill="#8EB50D" points="357.3,70.6 357.6,35.3 346.9,35.3 347.3,70.6 	" />
            </g>
        </svg>
    );
}



/** WEBPACK FOOTER **
 ** ../src/widgets/components/ui/svg/comeon_box.js
 **/